import firebase from 'firebase/app'
import 'firebase/database'
import { functions } from '@/firebase'

export default {
  namespaced: true,
  state: {
    exports: {},
    exportsRef: null
  },
  getters: {
    exports (state) {
      return state.exports
    }
  },
  mutations: {
    setExports (state, payload) {
      if (payload) state.exports = payload
      else state.exports = {}
    },
    setExportsRef (state, payload) {
      state.exportsRef = payload
    }
  },
  actions: {
    loadExports ({ state, commit, rootState }) {
      if (state.exportsRef) {
        // Make sure we only register one value listener at a time
        state.exportsRef.off()
      }

      if (rootState.auth.user && rootState.auth.user.uid) {
        const uid = rootState.auth.user.uid
        const exportsRef = firebase
          .database()
          .ref('placements')
          .orderByChild('userId')
          .equalTo(uid)
        commit('setExportsRef', exportsRef)

        exportsRef.on('value', snapshot => {
          const exports = snapshot.val()
          commit('setExports', exports)
        })
      }
    },
    async export (context, { testId, target }) {
      return functions.httpsCallable('placements-compile')({ testId, target })
    }
  }
}
